import { serializable, alias, list, object } from 'serializr';

export class SourceCO2eData {
  @serializable(alias('label'))
  fuelName?: string;

  @serializable(alias('total_co2e'))
  totalCO2e?: number;

  @serializable
  percentage?: number;
}

export class SourceCO2eResponse {
  @serializable(alias('source_co2e', list(object(SourceCO2eData))))
  sourceCO2e?: SourceCO2eData[];
}
